import type { ReactElement } from 'react'

import { DividendTable } from './Table'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
// import { AnotationList } from '@/components/enlayouts/Ir/AnotationList'
import { AHeading } from '@/components/enlayouts/Ir/Heading'
import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'

import { useMpocketScript } from '@/hooks/useMpocketScript'
import type { StockDividendProps } from '@/types/stockDividend'

export const DividendPage = ({ items }: StockDividendProps) => {
  useMpocketScript('//irpocket.com/141A/irpocket/ir-stock-dividend_en.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/ir-stock-dividend_en.js')


  /*
  const anotationlist: string[] = [
    '2022年6月期（実績）及び2023年6月期第2四半期累計期間（実績）の1株当たり当期（四半期）純利益は期中平均発行済株式数により算出しております。',
    '2023年6月期（予想）の1株当たり当期（四半期）純利益は公募予定株式数（23,800,000株）を含めた予定期中平均発行済株式数により算出し、オーバーアロットメントによる売出しに関連する第三者割当増資分（最大3,848,300株）は考慮しておりません。',
    '2023年1月31日付で普通株式1株につき200株の割合で株式分割を行っておりますが、2022年6月期の期首に当該株式分割が行われたと仮定し、1株当たり当期（四半期）純利益を算出しています。',
  ]
  */

  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Dividends and Shareholder Returns"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>Basic Policy on Profit Distribution</AHeading>
        <Paragraph id="irp-highlight-table-dividend1_en" />
        <Spacer h={{ sp: 70, pc: 100 }} />
        <AHeading>Dividends per Share</AHeading>
        <DividendTable items={items} />
        <Spacer h={{ sp: 50, pc: 60 }} /> 
        {/* <div id="irp-chart-graph-dividendchart" data-style="graph-dividendchart_en-style"/> */}
        {/* {/*<Spacer h={{ sp: 50, pc: 80 }} /> */}
        {/* <AnotationList listItem={anotationlist} /> */} 
        {/* <Spacer h={{ sp: 70, pc: 100 }} /> */}
        <Spacer h={{ sp: 70, pc: 80 }} />
        <AHeading>Shareholder Benefit Program</AHeading>
        <Paragraph>Shareholder benefits are not provided.</Paragraph>
      </section>
    </Layout>
  )
}

DividendPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Stock Information', path: '/en/ir/stock/' },
    { name: 'Dividends and Shareholder Returns', path: '' },
  ]

  return (
    <>
      <Head
        title="Dividends and Shareholder Returns"
        description="Basic policy on profit distribution and information on dividends."
        ogp={{ url: 'en/ir/stock/dividend/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
